import lenisScroll from './module/lenisScroll.js'
import menuMobile from './module/menuMobile.js'
import scrollMarkers from './module/scrollMarkers.js'
import loadAnimations from './module/animation-switcher.js'
import contactForm from './module/contactForm.js'
// import preventZoom from './module/preventZoom.js'
// import alertRotateDevice from './module/alertRotateDevice.js'
// import cookies from './module/cookies.js'
// import darkModeOS from './module/darkModeOS.js'

/**
 * Módulos por página: se cargan con import() solo si su markup existe, así
 * esbuild los separa en chunks (Swiper y Leaflet no viajan en el bundle base).
 * (No se usa inc/footer/{page}-scripts.php porque estos módulos importan
 * dependencias npm que requieren el bundle de esbuild.)
 */
function pageModules () {
  if (document.querySelector('.hero-slider')) {
    import('./module/heroSwiper.js').then(({ default: heroSwiper }) => heroSwiper())
  }
  if (document.querySelector('.consult-bg')) {
    import('./module/parallax.js').then(({ default: parallax }) => parallax(-0.2))
  }
  if (document.querySelector('[data-gallery]')) {
    import('./module/gallery.js').then(({ default: gallery }) => gallery())
  }
  if (document.getElementById('contact-map')) {
    import('./module/contactMap.js').then(({ default: contactMap }) => contactMap())
  }
}

function functions (deviceData) {
  lenisScroll()
  menuMobile(deviceData)
  scrollMarkers(deviceData)
  loadAnimations(deviceData) // motor nativo (IntersectionObserver) en idle, con failsafe
  contactForm()
  pageModules()
}

export default functions
